import { PartnerReport } from "generated/graphql";
import { ReportList } from "../../../Shared/types/Report";
const reportList: ReportList = [
  {
    type: PartnerReport.User,
    name: "User Report",
    description:
      "Contact information, available balance, and DailyPay Account information for your users.",
  },
  {
    type: PartnerReport.Balance,
    name: "Balance Report",
    description: "Outstanding DailyPay balance information for your users.",
  },
];

export default reportList;
